import React from 'react';

export default class Loading extends React.Component {
  render(){
    return (<span><i className="fa fa-spinner fa-pulse fa-fw"></i></span>)
  }
}
